var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoicesIntegration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_19405)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M65.9996 131.999C102.45 131.999 131.999 102.45 131.999 65.9996C131.999 29.549 102.45 0 65.9996 0C29.549 0 0 29.549 0 65.9996C0 102.45 29.549 131.999 65.9996 131.999Z",
    fill: "#ABD5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7714 44.941L28.7566 48.2062H29.0894L32.1782 44.941L35.1635 48.2062H35.4962L38.5851 44.941L41.5608 48.1966C41.5784 47.7786 42.2094 31.4082 31.0852 31.4082C26.5309 31.4082 22.623 34.3788 22.623 48.2062H22.6825L25.7714 44.941Z",
    fill: "#2F97C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.084 31.4082C34.9162 31.4082 39.2964 34.6932 39.2964 43.4528V95.4627C39.2964 103.401 43.9498 107.507 48.6033 107.507H99.244V44.0001C99.244 35.5144 94.5905 31.4082 87.4733 31.4082H31.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.422 96.7082L103.274 93.2638L100.015 96.7082L96.8672 93.2638L93.6086 96.7082L90.4603 93.2638L87.2018 96.7082L84.0535 93.2638L80.795 96.7082L77.6466 93.2638L74.3881 96.7082L71.2398 93.2638L67.9813 96.7082L64.8329 93.2638L61.5744 96.7082L58.3093 93.1367H58.1778C58.1778 101.973 53.8498 107.506 48.6035 107.506H99.2442C108.794 107.506 109.363 96.0096 109.377 93.5841L106.421 96.7089L106.422 96.7082Z",
    fill: "#63B1D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5424 46.4883H47.2383V48.7471H92.5424V46.4883Z",
    fill: "#2C3B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5424 57.0684H47.2383V59.3271H92.5424V57.0684Z",
    fill: "#2C3B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5428 71.0977H68.8789V73.3564H92.5428V71.0977Z",
    fill: "#2C3B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5428 80.6387H68.8789V82.8974H92.5428V80.6387Z",
    fill: "#2C3B60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1799 112.512C53.8385 112.512 61.6683 104.682 61.6683 95.0236C61.6683 85.365 53.8385 77.5352 44.1799 77.5352C34.5213 77.5352 26.6914 85.365 26.6914 95.0236C26.6914 104.682 34.5213 112.512 44.1799 112.512Z",
    fill: "#A846A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0773 100.165C53.1484 104.245 48.9944 107.069 44.1816 107.069C38.3609 107.069 33.504 102.94 32.3809 97.4512",
    stroke: "white",
    strokeWidth: 1.46912,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9727 88.6239C36.1036 85.2317 39.8785 82.9766 44.1801 82.9766C49.8451 82.9766 54.5962 86.8866 55.8824 92.1556",
    stroke: "white",
    strokeWidth: 1.46912,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9648 100.092L31.8857 96.5156L35.5431 98.4791",
    stroke: "white",
    strokeWidth: 1.46912,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8717 88.9609L56.5437 92.7976L52.6211 91.4401",
    stroke: "white",
    strokeWidth: 1.46912,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_19405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIntegration);
export default __webpack_public_path__ + "static/media/InvoicesIntegration.553b2a5f62aeeb89c7999801dcdb10c6.svg";
export { ForwardRef as ReactComponent };